import { render, staticRenderFns } from "./ComplianceContentComp.vue?vue&type=template&id=45ca0e18"
import script from "./ComplianceContentComp.vue?vue&type=script&lang=js"
export * from "./ComplianceContentComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports